// Module
var code = `<form name="\$ctrl.form">
  <div class="form-column">
    <form-section-field field-title="'Category'">
      <gl-category-select
        ng-required="true"
        action-type="\$ctrl.actionType"
        ng-model="\$ctrl.category"
        is-selectize="true"
        ng-change="\$ctrl.categoryChanged()"
        single-accounts-only="false"></gl-category-select>
    </form-section-field>
    <form-section-field field-title="'Remarks'">
      <input class="remarks" type="text" ng-required="true" ng-model="\$ctrl.remarks">
    </form-section-field>
  </div>

  <gl-category-input units="\$ctrl.categoryUnits"></gl-category-input>

  <table class="table">
    <thead>
      <th class="th--index">#</th>
      <th>Account</th>
      <th>Debit amount</th>
      <th>Credit amount</th>
    </thead>
    <tbody class="tbody">
    <tr ng-if="\$ctrl.memoMode === 'DEBIT'">
      <td></td>
      <td>
        <select disabled>
          <option selected>Product GL account</option>
        </select>
      </td>
      <td>
        <cash value="\$ctrl.calculateAmount()" ng-disabled="true"></cash>
      </td>
      <td>
        <cash ng-disabled="true" value="0"></cash>
      </td>
      <td>

      </td>
    </tr>

    <tr ng-if="\$ctrl.memoMode === 'CREDIT'">
      <td></td>
      <td>
        <select disabled>
          <option selected>Product GL account</option>
        </select>
      </td>
      <td>
        <cash ng-disabled="true" value="0"></cash>
      </td>
      <td>
        <cash value="\$ctrl.calculateAmount()" ng-disabled="true"></cash>
      </td>
    </tr>

    <tr>
      <td></td>
      <td class="text-right">Total:</td>
      <td>
        <cash
          min="\$ctrl.limits.debit.min"
          max="\$ctrl.limits.debit.max"
          value="\$ctrl.memoMode === 'DEBIT' ? \$ctrl.calculateAmount() : '0'"
          ng-disabled="true">
        </cash>
      </td>
      <td>
        <cash
          min="\$ctrl.limits.credit.min"
          max="\$ctrl.limits.credit.max"
          value="\$ctrl.memoMode === 'CREDIT' ? \$ctrl.calculateAmount() : '0'"
          ng-disabled="true">
        </cash>
      </td>
    </tr>
    </tbody>
  </table>

  <validator condition="\$ctrl.validateAmount()"></validator>
</form>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/term-deposits/deposit-memo/deposit-memo-form.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;